import type { SignupModalHeaderCopy } from '../../experiments/signup-modal/highlight-copy'
import { type UseSignUpOrSignInOptions, useSignUpOrSignIn } from '../../hooks/useSignUpOrSignIn'
import { EmailSignIn } from '../email-sign-in'

export interface EmailStepProps extends UseSignUpOrSignInOptions {
  onCloseClick?: () => void
  signupModalHeader?: SignupModalHeaderCopy
}

export function EmailStep({ onCloseClick, signupModalHeader, ...options }: EmailStepProps) {
  const { email, isLoading, error, handleEmailSubmit } = useSignUpOrSignIn(options)

  return (
    <EmailSignIn
      initialEmail={email}
      isLoading={isLoading}
      error={error}
      signupModalHeader={signupModalHeader}
      onSubmit={handleEmailSubmit}
      appId={options.appId}
      featureCode={options.featureCode}
      fromComponent={options.fromComponent}
      nextUrl={options.nextUrl}
      onCloseClick={onCloseClick}
    />
  )
}
